module.exports = __webpack_public_path__ + "img/guide-06.ce9631a6.jpg";